﻿(function () {
    'use strict';

    var serviceId = 'routemediator';

    angular
        .module('app.common')
        .factory(serviceId, ['$location', '$rootScope', 'logger', 'configConstants', 'datacontext', '$timeout', 'tmhDynamicLocale', '$state', 'config',
    function ($location, $rootScope, logger, configConstants, datacontext, $timeout, tmhDynamicLocale, $state, config) {
        var handleRouteChangeError = false;
        var service = {
            setRoutingHandlers: function setRoutingHandlers() {
                $rootScope.$on('$stateChangeSuccess',
                    function (event, current, previous) {
                        handleRouteChangeError = false;
                        var msg = 'Success routing: <br />' + current.url + '.html';
                        logger.debug(msg);
                    });
                $rootScope.$on('$stateChangeError',
                    function (event, current, previous, rejection) {                        
                        if (handleRouteChangeError) { return; }
                        handleRouteChangeError = true;
                        var msg = 'Error routing:  <br />' + current.url + (current && current.name) + '.' + (rejection.msg || '') + 'html';
                        logger.NotyError(msg, current, serviceId, true);
                    });
                $rootScope.$on('$stateChangeStart',
                    function (event, next) {                        
                        var authorised;
                        $rootScope.$broadcast(config.events.controllerActivateInit);
                        if (next.access !== undefined) {
                            authorised = datacontext.authorization.authorize(next.access.loginRequired,next.access.isRoot);
                            if (authorised === configConstants.enums.authorise.loginRequired) {
                                event.preventDefault();
                                $state.go('login');                                
                            } else if (authorised === configConstants.enums.authorise.logged) {                                
                                event.preventDefault();
                                $state.go('root');                                
                            }                            
                        }
                    });
                $rootScope.$on('$translateChangeSuccess', function (event, data) {
                   tmhDynamicLocale.set(data.language.toLowerCase());                   
                });
            }
        };
        return service;
    }]);
})();